import _createClass from "/home/circleci/project/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/home/circleci/project/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _inherits from "/home/circleci/project/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/home/circleci/project/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/circleci/project/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _wrapNativeSuper from "/home/circleci/project/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/**
 * Base Consent Error
 */
export var AnalyticsConsentError = /*#__PURE__*/function (_Error) {
  _inherits(AnalyticsConsentError, _Error);
  var _super = _createSuper(AnalyticsConsentError);
  /**
   *
   * @param name - Pass the name explicitly to work around the limitation that 'name' is automatically set to the parent class.
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Classes/extends#using_extends
   * @param message - Error message
   */
  function AnalyticsConsentError(name, message) {
    var _this;
    _classCallCheck(this, AnalyticsConsentError);
    _this = _super.call(this, message);
    _this.name = name;
    return _this;
  }
  return _createClass(AnalyticsConsentError);
}( /*#__PURE__*/_wrapNativeSuper(Error));